import React from "react";
import "./index.css";
import cn from "classnames";
import BgTransformer from "layout/BgTransformer";
import PixelationLayer from "layout/PixelationLayer";
import Textarea from "layout/Textarea/Textarea";
import ContentEditable from "../../../layout/ContentEditable/ContentEditable";
import {useSetting} from "contexts/setting";
import {useEdits} from "contexts/edits";
import {useBgUrl} from "hooks/useBgUrl";
import {checkIfIDE} from "data/products/index";
import {checkProductInText} from "libs/utils";
import {TEXT_CLASSNAMES, PLACEHOLDERS} from "data/constants";
import {useLogoUrl} from "../../../hooks/useLogoUrl";
import AirBanner, {isAirBanner} from "pages/Releases/AirBanner";

const HorizontalFeatures = ({id, zoom}) => {
  const {product, type, channel, layoutOption} = useSetting();
  const {url: bgUrl} = useBgUrl();
  const {titles, features, productNames} = useEdits();

  const defaultProductName = product.altLabel || product.label;
  const productName = productNames[id] || productNames.main || defaultProductName;
  const logoSrc = useLogoUrl(id);
  const logoClass = cn("logo", {ide: checkIfIDE(product.value, type.value)});

  const title = titles[id] ?? titles.main ?? PLACEHOLDERS.en.title;
  const featureText = features[id] ?? features.main ?? PLACEHOLDERS.en.features;

  const isProductInTitle = checkProductInText(productName, title);

  // JetBrains Air replaces the whole banner rather than restyling this one:
  // every channel that lists the product draws the same skin (src/data/offering.ts).
  if (isAirBanner(product.value)) return <AirBanner id={id} zoom={zoom} />;

  return (
    <div
      id={id}
      className={cn("template", product.value, "horizontal-features", `layout-${layoutOption}`)}
      style={{"--zoom-level": zoom}}
    >
      <div>
        <BgTransformer src={bgUrl} id={id} />
        <PixelationLayer />
        <div className="content">
          <div className="title-wrap">
            <div className="title">
              <Textarea id={id} text={title} />
            </div>
          </div>
          <div className="features">
            <ContentEditable id={id} text={featureText} isList={true} />
          </div>
          <header className="template-header">
            <div className={logoClass}>
              <img src={logoSrc} alt="logo" />
            </div>
            {!isProductInTitle && (
              <div className="product-name">
                <ContentEditable id={id} text={productName} />
              </div>
            )}
          </header>
        </div>
      </div>
    </div>
  );
};

export default HorizontalFeatures;
